import type { VariationType } from '@/models/Programme/VariationType'

export enum PagesWithVideo {
  dashboard = 'dashboard',
  studentAccessSettings = 'student_access_settings',
  studentUpload = 'student_upload',
  studentOverview = 'student_overview',
  interviewSessions = 'interview_sessions',
  addStudents = 'add_students',
  addSingleStudent = 'add_single_student',
  selfRegistration = 'self_registration',
  safScore = 'saf_score',
  yearGroups = 'year_groups',
  subjectsQualifications = 'subjects_qualifications',
  interviewerDashboard = 'interviewer_dashboard',
}

export type VideoUrl = {
  [K in VariationType]: string;
}

export type TutorialVideos = {
  [K in PagesWithVideo]?: VideoUrl
}

export const routeToPageWithVideoMap: Partial<Record<string, PagesWithVideo>> = {
  'index': PagesWithVideo.dashboard,
  'organisation.student-access-settings.list': PagesWithVideo.studentAccessSettings,
  'students.upload-wizard': PagesWithVideo.studentUpload,
  'students.overview': PagesWithVideo.studentOverview,
  'interviews.request.list': PagesWithVideo.interviewSessions,
  'students.add-options': PagesWithVideo.addStudents,
  'students.add-student': PagesWithVideo.addSingleStudent,
  'organisation.self-registration.list': PagesWithVideo.selfRegistration,
  'students.saf': PagesWithVideo.safScore,
  'organisation.year-groups.list': PagesWithVideo.yearGroups,
  'organisation.subjects-and-qualifications': PagesWithVideo.subjectsQualifications,
  'interviewer-days.list': PagesWithVideo.interviewerDashboard,
}
